import React from "react";
import Header from "../../Layout/Header";
import Footer from "../../Layout/Footer";
import { Link } from "react-router-dom";
import "./trainig.css";
const Training = () => {
  return (
    <>
      <Header />
 
            <div className="container content col-md-8 mx-auto ">
              <div class="text-center mt-5">
                <h1> Training And Certification</h1>
              </div>
              <p>
                Hypnosis training courses have extreme variability in terms of
                rigor. GAFHC has developed the most comprehensive and rigorous
                hypnotherapy training in the world designed by a top-tier group
                of medical doctors, dentists, and veteran hypnotherapists.
                Following the completion of the GAFHC training program, a
                hands-on approach to certification is necessary to verify that
                the student is capable of implementing clinical hypnosis in a
                professional manner under variable circumstances.
              </p>
              <p className="my-3">
                Contact us:
                <Link to={"/contact"} style={{ color: "#7CB9E8" }}>
                 &nbsp; contact if you’d like to get certified by GAFHC.
                </Link>
              </p>
            </div>

<div class="container mb-4">
          <div className="video-overlay ">
            <div className="video-container">
              <video autoPlay loop muted>
                <source src="img/video1.mp4" type="video/mp4" />
              </video>
            </div>

            {/* <div className="overlay"></div> */}

          </div>
          </div>
   
      <Footer />
    </>
  );
};

export default Training;
